import { camelizeObject } from '@cvt/helpers/object';

export const mapConnectionData = (data: Connections.ConnectionApi): Connections.Connection => ({
  ...camelizeObject<Connections.Connection>(data),
  createdAt: new Date(data.created_at),
  updatedAt: new Date(data.updated_at),
});
